import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Multimedia, ViewMode } from '@src/models';

import { PhotoSize } from './types';

/**
 * Компонент для отображения, добавления и удаления картинки объекта
 * @param {ViewMode} mode {@link ViewMode} - режим отображения (view или edit)
 * @param {string} text - описание картинки
 * @param {Multimedia} newPhoto {@link Multimedia} - новая картинка
 * @param {string} photoSrc - ссылка картинки
 * @param {boolean} showPreview - Флаг, разрешающий отображение превью картинки при клике
 * @param {Multimedia} photoChange {@link Multimedia} - возвращаемый объект новой картинки
 * @param {void} photoDelete - событие для удаления фотографии
 * @param {PhotoSize} size {@link PhotoSize} - размер картинки (стандартный)
 * @param {string} width - ширина картинки (нестандартный размер)
 * @param {string} height - высота картинки (нестандартный размер)
 * @param {string} borderRadius - углы картинки (нестандартный размер)
 * @param {boolean} rounded - скругление краев
 * @param {boolean} loading - отображение загрузки
 *
 * @see https://www.figma.com/file/tdtoaaGrQa3XOG9Qqv96VI/Unions-(Taiga-3.0)?type=design&node-id=727-66631&mode=dev
 */
@Component({
  selector: 'app-base-photo',
  templateUrl: './base-photo.component.html',
  styleUrls: ['./base-photo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// TODO: Научить работать с формами через extends AbstractTuiControl
export class BasePhotoComponent {
  @Input() mode: ViewMode = 'view';
  @Input() text?: string;
  @Input() newPhoto?: Multimedia;
  @Input() photoSrc?: string;
  @Input() showPreview: boolean = true;
  @Output() photoChange = new EventEmitter<Multimedia | undefined>();
  @Output() photoDelete = new EventEmitter<void>();
  @Output() openPreviewDialog = new EventEmitter<void>();

  @Input() size: PhotoSize = 'xxl';
  @Input() width?: string;
  @Input() height?: string;
  @Input() borderRadius?: string;
  @Input() rounded: boolean = false;
  @Input() loading: boolean = false;
}
